/* NOURA x Quasi layout - behaviour */
(function () {
  if (window.__nqInit) return;
  window.__nqInit = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- generic scroll-snap carousel ---------- */
  function initCarousel(root) {
    if (root.__nq) return; root.__nq = true;
    var track = $('.nq-track', root);
    if (!track) return;
    var slides = $$('.nq-slide', track);
    var dotsWrap = $('.nq-dots', root);
    var prev = $('.nq-arrow--prev', root), next = $('.nq-arrow--next', root);
    var dots = [];
    if (dotsWrap && !dotsWrap.children.length) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'nq-dot'; d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(d); dots.push(d);
      });
    }
    function idx() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
      slides.forEach(function (s, i) {
        var m = s.offsetLeft + s.offsetWidth / 2, dd = Math.abs(m - c);
        if (dd < bd) { bd = dd; best = i; }
      });
      return best;
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var s = slides[i];
      track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
    }
    function sync() {
      var i = idx();
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      root.dispatchEvent(new CustomEvent('nq:slide', { detail: i }));
    }
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    root.__go = go;
    setTimeout(sync, 50);
  }

  /* ---------- gallery ---------- */
  function initGallery(g) {
    if (g.__nqg) return; g.__nqg = true;
    initCarousel(g);
    var thumbs = $$('.nq-gal__t', g), list = $('.nq-gal__tlist', g);
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { g.__go(i); }); });
    g.addEventListener('nq:slide', function (e) {
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === e.detail); });
      var a = thumbs[e.detail];
      if (a && list) list.scrollTo({ left: a.offsetLeft - list.clientWidth / 2 + a.offsetWidth / 2, behavior: 'smooth' });
    });
    var tp = $('.nq-gal__tarrow--prev', g), tn = $('.nq-gal__tarrow--next', g);
    var cur = function () { var a = $('.nq-gal__t.is-active', g); return a ? thumbs.indexOf(a) : 0; };
    if (tp) tp.addEventListener('click', function () { g.__go(cur() - 1); });
    if (tn) tn.addEventListener('click', function () { g.__go(cur() + 1); });
  }

  /* ---------- before / after ---------- */
  function initBA(el) {
    if (el.__nq) return; el.__nq = true;
    var input = $('input', el);
    var set = function (v) { el.style.setProperty('--pos', v + '%'); };
    set(input.value || 50);
    input.addEventListener('input', function () { set(input.value); });
  }

  /* ---------- evergreen countdowns ---------- */
  function pad(n) { return String(n).padStart(2, '0'); }
  function initTimers() {
    $$('[data-nq-timer]').forEach(function (el) {
      if (el.__nq) return; el.__nq = true;
      var mins = parseInt(el.getAttribute('data-nq-timer'), 10) || 360;
      var key = 'nqT_' + (el.getAttribute('data-key') || mins);
      var end = 0;
      try { end = +sessionStorage.getItem(key); } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
      var fmt = el.getAttribute('data-fmt') || 'hms';
      function tick() {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (s <= 0) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} s = mins * 60; }
        var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
        el.textContent = fmt === 'words' ? (h + ' HRS : ' + pad(m) + ' MIN : ' + pad(x) + ' SEC') : (pad(h) + ':' + pad(m) + ':' + pad(x));
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- cart helpers ---------- */
  /* trigger: the button that started the add, so closing the drawer puts keyboard focus back on it */
  function refreshCart(payload, trigger) {
    var drawer = document.querySelector('cart-drawer');
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign(payload, drawer ? { sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname } : {}))
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        if (drawer && typeof drawer.renderContents === 'function' && j.sections) {
          drawer.classList.remove('is-empty');
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(trigger || document.activeElement);
          drawer.renderContents(j);
        } else {
          window.location.href = '/cart';
        }
      });
  }

  /* ---------- buy box ---------- */
  function initBuyBox(bb) {
    if (bb.__nq) return; bb.__nq = true;
    var tiers = $$('.nq-tier', bb).filter(function (t) { return !t.disabled && !t.classList.contains('is-disabled'); });
    var gifts = $('[data-nq-gifts]', bb);
    var qtyInput = $('[name="quantity"]', bb);
    var atc = $('.nq-atc', bb), atcNow = $('.nq-atc__now', bb), atcWas = $('.nq-atc__was', bb);
    /* add-to-cart errors (e.g. not enough stock) show as a line under the button, not a browser alert */
    function atcError(msg) {
      var el = $('.nq-atc-err', bb);
      if (!msg) { if (el) el.parentNode.removeChild(el); return; }
      if (!el) {
        el = document.createElement('p');
        el.className = 'nq-atc-err';
        el.setAttribute('role', 'alert');
        if (atc && atc.parentNode) atc.parentNode.insertBefore(el, atc.nextSibling); else bb.appendChild(el);
      }
      el.textContent = msg;
    }
    function pick(t) {
      atcError('');
      tiers.forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-checked', x === t ? 'true' : 'false'); });
      if (qtyInput) qtyInput.value = t.getAttribute('data-qty') || 1;
      if (atcNow) atcNow.textContent = t.getAttribute('data-now') || '';
      if (atcWas) atcWas.textContent = t.getAttribute('data-was') || '';
      if (gifts) gifts.hidden = t.getAttribute('data-gifts') !== '1';
    }
    tiers.forEach(function (t) { t.addEventListener('click', function () { pick(t); }); });
    var pre = $('.nq-tier.is-active', bb) || tiers[tiers.length - 1];
    if (pre) pick(pre);

    var sub = $('.nq-sub-box', bb);
    if (sub) sub.addEventListener('click', function () { sub.classList.toggle('is-on'); });

    var form = $('form.nq-form', bb);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      atcError('');
      var trigger = e.submitter || atc;
      if (atc) { atc.disabled = true; }
      refreshCart({ items: [{ id: +$('[name="id"]', form).value, quantity: +(qtyInput ? qtyInput.value : 1) }] }, trigger)
        .catch(function (err) { atcError((err && (err.description || (err.status && err.message))) || 'Could not add to cart. Please try again.'); })
        .then(function () { if (atc) atc.disabled = false; });
    });

    $$('.nq-up__add', bb).forEach(function (b) {
      b.addEventListener('click', function () {
        var id = +b.getAttribute('data-variant');
        if (!id) return;
        b.disabled = true;
        refreshCart({ items: [{ id: id, quantity: 1 }] }, b).catch(function () {}).then(function () { b.disabled = false; });
      });
    });
  }

  /* ---------- ingredient list toggle ---------- */
  function initIng(s) {
    if (s.__nq) return; s.__nq = true;
    var btn = $('.nq-ing__btn', s), list = $('.nq-ing__list', s);
    if (btn && list) btn.addEventListener('click', function () { list.classList.toggle('is-open'); });
  }

  /* ---------- marquee: duplicate content for seamless loop ---------- */
  function initMarquee(m) {
    if (m.__nq) return; m.__nq = true;
    var inner = $('.nq-marquee__inner', m);
    if (inner && !inner.__dup) { inner.__dup = true; inner.innerHTML += inner.innerHTML; }
  }

  function boot() {
    $$('.nq-gal').forEach(initGallery);
    $$('[data-nq-carousel]').forEach(initCarousel);
    $$('.nq-ba').forEach(initBA);
    $$('.nq-bb').forEach(initBuyBox);
    $$('.nq-ing').forEach(initIng);
    $$('.nq-marquee').forEach(initMarquee);
    initTimers();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 50); });
})();

/* order-by date: tomorrow in the shopper's timezone, e.g. "September 25" (runs once even if nq.js is included twice) */
(function () {
  if (window.__nqDateInit) return;
  window.__nqDateInit = true;
  var d = new Date(); d.setDate(d.getDate() + 1);
  var txt = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  document.querySelectorAll('[data-nq-date]').forEach(function (el) { el.textContent = txt; });
})();

/* nq-sticky-to-bundles: the theme's sticky bar button scrolls to the bundle picker (never adds a single tube).
   The top offer bar does the same when it links to the page you are already on (instead of reloading it).
   One listener only, even if nq.js is included more than once. */
(function () {
  if (window.__nqStickyInit) return;
  window.__nqStickyInit = true;
  function samePage(a) {
    try { var u = new URL(a.href, location.href); return u.origin === location.origin && u.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, ''); } catch (err) { return false; }
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    var btn = t && t.closest('[data-button-behavior="scroll_to_section"]');
    if (!btn && t) { var bar = t.closest('a.np-tb'); if (bar && samePage(bar) && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) btn = bar; }
    var tiers = document.querySelector('.nq-bb .nq-tiers');
    if (!btn || !tiers) return;
    e.preventDefault(); e.stopPropagation();
    var head = document.querySelector('.bundle-h, .nq-bundle-h') || tiers;
    var y = head.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    tiers.classList.add('nq-flash'); setTimeout(function () { tiers.classList.remove('nq-flash'); }, 1400);
  }, true);
})();
